import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLightbulb = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M4.5 8.25C4.5 10.2391 5.29018 12.1468 6.6967 13.5533C8.10322 14.9598 10.0109 15.75 12 15.75C13.9891 15.75 15.8968 14.9598 17.3033 13.5533C18.7098 12.1468 19.5 10.2391 19.5 8.25C19.5 6.26088 18.7098 4.35322 17.3033 2.9467C15.8968 1.54018 13.9891 0.75 12 0.75C10.0109 0.75 8.10322 1.54018 6.6967 2.9467C5.29018 4.35322 4.5 6.26088 4.5 8.25Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 18.75H15",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 21.75H15",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 23.25V21.75",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 15.75V12L9.75 9.75",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12 12L14.25 9.75",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}));
});
export default SvgLightbulb;
